import zh from "./zh.json";
import twLocale from "element-ui/lib/locale/lang/zh-TW";
export default {
  ...zh,
  ...twLocale,
};